import { Slide } from "@jelly/lesson";

import { task as task01 } from "../../../../../task/course-05/lesson-26/task-01";

const task: Slide = {
  titleHtml:
    "Reorder the images below according to the Young’s modulus values of the materials<br>depicted in the pictures. The pictures are crops from the theory part.<br>Order in ascending order.",
  description: "Drag and drop pictures.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task01.id,
        },
      },
    },
  },
};

export default task;
